import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getContextualUrl } from '../scripts/utils';
import { findBestMatch } from 'string-similarity';
export var filterTopNavs = function filterTopNavs(navItems) {
  var quickNavBarItems = navItems.filter(function (navItem) {
    return navItem.isQuickNav || navItem.isMobileNav;
  });
  var revenueNavBarItems = navItems.filter(function (navItem) {
    return navItem.isRevenueNav;
  });
  var revenueHasMobileItems = navItems.some(function (navItem) {
    return navItem.isRevenueNav && navItem.isMobileNav;
  });
  return {
    quickNavBarItems: quickNavBarItems,
    revenueNavBarItems: revenueNavBarItems,
    revenueHasMobileItems: revenueHasMobileItems
  };
};
var transformToSlug = function transformToSlug(text) {
  return text.toLowerCase().replace('-', '').replace(' ', '');
};
var customPropsToObj = function customPropsToObj(customProps) {
  if (!customProps) {
    return {};
  }
  var customArr = customProps.split(';').filter(function (item) {
    return item !== '' && item !== ' ';
  });
  return customArr.reduce(function (acc, prop) {
    var propTuple = prop.split(':');
    acc[propTuple[0]] = propTuple[1];
    return acc;
  }, {});
};
var transformNavItem = function transformNavItem(_ref) {
  var navItem = _ref.navItem,
    teamNameSlug = _ref.teamNameSlug,
    locale = _ref.locale,
    currentSection = _ref.currentSection;
  var properties = navItem.properties,
    menuItems = navItem.menuItems,
    text = navItem.text,
    itemId = navItem.itemId;
  var customProperties = properties.customProperties,
    link = properties.link,
    target = properties.target,
    visible = properties.visible,
    forgeIcon = properties.icon;
  var customPropsList = customPropsToObj(customProperties);
  var isCurrentSection = (text === null || text === void 0 ? void 0 : text.toLowerCase()) === currentSection;
  var align = customPropsList.align,
    appears = customPropsList.appears,
    expires = customPropsList.expires,
    label = customPropsList.label,
    lang = customPropsList.lang,
    mobile = customPropsList.mobile,
    module = customPropsList.module,
    showDesktopIcon = customPropsList.showDesktopIcon,
    spotlight = customPropsList.spotlight;
  var isMobileNav = mobile === 'true';
  var isQuickNav = align !== 'right';
  var isRevenueNav = align === 'right';
  var isSpotlight = spotlight === 'true';
  var subnav = menuItems && menuItems.length ? transformSubnavItems(menuItems, teamNameSlug, locale) : false;
  var subnavModule = module ? module : false;
  var shouldOpenInNewWindow = target === '_blank';
  var icon = forgeIcon || (text === null || text === void 0 ? void 0 : text.toLowerCase()) || '';
  return {
    appears: appears,
    expires: expires,
    icon: icon,
    id: itemId,
    isCurrentSection: isCurrentSection,
    isHidden: visible === 'false',
    isMobileNav: isMobileNav,
    isQuickNav: isQuickNav,
    isRevenueNav: isRevenueNav,
    isSpotlight: isSpotlight,
    label: label,
    lang: lang === null || lang === void 0 ? void 0 : lang.toLowerCase(),
    shouldOpenInNewWindow: shouldOpenInNewWindow,
    showDesktopIcon: showDesktopIcon,
    subnav: subnav,
    subnavModule: subnavModule,
    text: text,
    url: getContextualUrl(link, teamNameSlug, locale)
  };
};
var getSubNavItems = function getSubNavItems(menuItems, MAX_ITEMS) {
  var visibleItemsCount = 0;
  return menuItems.reduce(function (selectedItms, subnavItem) {
    var _subnavItem$propertie = subnavItem.properties,
      visible = _subnavItem$propertie.visible,
      customProperties = _subnavItem$propertie.customProperties;
    var propertiesList = customPropsToObj(customProperties);
    var appearanceDate = propertiesList.appears * 1000;
    var expirationDate = propertiesList.expires * 1000;
    var isExpired = expirationDate ? Date.now() >= expirationDate : false;
    var appearing = appearanceDate ? Date.now() >= appearanceDate : true;
    if (visible !== 'false' && visibleItemsCount < MAX_ITEMS && !isExpired && appearing) {
      selectedItms.push(subnavItem);
      visibleItemsCount++;
    }
    return selectedItms;
  }, []);
};
var transformSubnavItems = function transformSubnavItems(subnavItems, teamNameSlug, locale) {
  var subNavHasGroups = subnavItems[0].menuItems && subnavItems[0].menuItems.length && subnavItems[0].menuItems.length > 0;
  var transformedSubnavItems = [];
  var MAX_ITEMS = 20;
  if (subNavHasGroups) {
    transformedSubnavItems = subnavItems.slice(0, MAX_ITEMS).map(function (group) {
      var menuItems = group.menuItems,
        title = group.text,
        id = group.itemId;
      var menuItemsCopy = getSubNavItems(menuItems, MAX_ITEMS);
      var groupItems = menuItemsCopy.map(function (subnavItem) {
        return transformSubnavItem(subnavItem, teamNameSlug, locale);
      });
      return {
        id: id,
        title: title,
        groupItems: groupItems
      };
    });
  } else {
    var subnavItemsCopy = getSubNavItems(subnavItems, MAX_ITEMS);
    transformedSubnavItems = subnavItemsCopy.map(function (subnavItem) {
      return transformSubnavItem(subnavItem, teamNameSlug, locale);
    });
  }
  return transformedSubnavItems;
};
var transformSubnavItem = function transformSubnavItem(subnavItem, teamNameSlug, locale) {
  var id = subnavItem.itemId,
    text = subnavItem.text,
    properties = subnavItem.properties;
  var link = properties.link,
    visible = properties.visible,
    target = properties.target,
    customProperties = properties.customProperties;
  var customPropsList = customPropsToObj(customProperties);
  var appears = customPropsList.appears,
    expires = customPropsList.expires,
    lang = customPropsList.lang;
  var shouldOpenInNewWindow = target === '_blank';
  return {
    id: id,
    isHidden: visible === 'false',
    lang: lang === null || lang === void 0 ? void 0 : lang.toLowerCase(),
    text: text,
    url: getContextualUrl(link, teamNameSlug, locale),
    appears: appears,
    expires: expires,
    shouldOpenInNewWindow: shouldOpenInNewWindow
  };
};
export var getActiveSection = function getActiveSection(reqPath, navItems, isMicrositeIndex) {
  if (!reqPath || reqPath === '/' || isMicrositeIndex) {
    return '';
  }
  var reqPathParts = reqPath.split('/').filter(Boolean);
  var reqPathFirstLevel = "/".concat(reqPathParts[0]);
  var itemsInCurrentSection = navItems.filter(function (item) {
    var link = item.properties.link;
    return link && link.startsWith(reqPathFirstLevel);
  });
  if (itemsInCurrentSection.length === 1) {
    var text = itemsInCurrentSection[0].text;
    return (text || '').toLowerCase();
  } else if (itemsInCurrentSection.length > 1) {
    var navLinks = itemsInCurrentSection.map(function (item) {
      return item.properties.link;
    });
    var _findBestMatch = findBestMatch(reqPath, navLinks),
      bestMatch = _findBestMatch.bestMatch;
    // Check for false positives
    var isSameSection = reqPath.startsWith(bestMatch.target);
    // if false positive, check if a subnav link equals the req path.
    var activeSectionItem = itemsInCurrentSection.find(function (item) {
      return isSameSection ? item.properties.link === bestMatch.target : item.menuItems.some(function (sub) {
        return sub.properties.link === reqPath;
      });
    });
    if (activeSectionItem && activeSectionItem.text) {
      return activeSectionItem.text.toLowerCase();
    }
  }
  return '';
};
export var transformHeaderData = function transformHeaderData(_ref2) {
  var navItems = _ref2.navItems,
    sharedNav = _ref2.sharedNav,
    teamNameSlug = _ref2.teamNameSlug,
    locale = _ref2.locale,
    _ref2$teamData = _ref2.teamData,
    teamData = _ref2$teamData === void 0 ? {} : _ref2$teamData,
    currentSection = _ref2.currentSection;
  if (!navItems || !navItems.length) {
    return [];
  }
  var navs = navItems.map(function (navItem) {
    // 'data' property can be commonly found on Global nav data in Club context
    // e.g. https://feen.cms.mlbinfra.com/cms/api/public/menuitems/_navs/header/bal/global-nav
    var sharedNavName = navItem.properties.data;
    var item = navItem;
    if (sharedNavName) {
      var matchingSharedNavItem = sharedNav.menuItems.find(function (menuItem) {
        return menuItem.text === sharedNavName;
      });
      if (matchingSharedNavItem) {
        // keep orginal custom props to allow club overrides
        var originalCustomProps = navItem.properties.customProperties;
        item = matchingSharedNavItem;
        item.properties.customProperties = originalCustomProps;
      }
    }
    var transformedNavItem = transformNavItem({
      navItem: item,
      sharedNav: sharedNav,
      teamNameSlug: teamNameSlug,
      locale: locale,
      currentSection: currentSection
    });

    // Handle teammodule subnav
    if (transformedNavItem.subnavModule === 'teammodule') {
      if (!teamData.leagues) {
        return {};
      }
      transformedNavItem.teamData = teamData;
    }
    return transformedNavItem;
  });
  return navs;
};
export var sortTeams = function sortTeams() {
  var teams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return teams.sort(function (a, b) {
    return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
  });
};
export var transformTeamsData = function transformTeamsData(teamsData, locale) {
  var teamsDataOut = {
    leagues: [{
      name: 'American League',
      abr: 'AL',
      divisions: [{
        name: 'AL East',
        teams: []
      }, {
        name: 'AL Central',
        teams: []
      }, {
        name: 'AL West',
        teams: []
      }]
    }, {
      name: 'National League',
      abr: 'NL',
      divisions: [{
        name: 'NL East',
        teams: []
      }, {
        name: 'NL Central',
        teams: []
      }, {
        name: 'NL West',
        teams: []
      }]
    }]
  };
  var AL_EAST = [];
  var AL_CENTRAL = [];
  var AL_WEST = [];
  var NL_EAST = [];
  var NL_CENTRAL = [];
  var NL_WEST = [];
  if (!teamsData || teamsData.length === 0) {
    return {};
  }
  teamsData.forEach(function (team) {
    var division = team.division,
      id = team.id,
      name = team.name,
      shortName = team.shortName,
      teamName = team.teamName;
    var teamSlug = transformToSlug(teamName);
    var teamObj = {
      id: id,
      name: name,
      logo: "//www.mlbstatic.com/team-logos/".concat(team.id, ".svg"),
      shortName: shortName,
      url: getContextualUrl("/".concat(teamSlug), '', locale)
    };
    if (division) {
      switch (division.id) {
        case 200:
          AL_WEST.push(teamObj);
          break;
        case 201:
          AL_EAST.push(teamObj);
          break;
        case 202:
          AL_CENTRAL.push(teamObj);
          break;
        case 203:
          NL_WEST.push(teamObj);
          break;
        case 204:
          NL_EAST.push(teamObj);
          break;
        case 205:
          NL_CENTRAL.push(teamObj);
          break;
        default:
          break;
      }
    }
  });
  teamsDataOut.leagues[0].divisions[0].teams = sortTeams(AL_EAST);
  teamsDataOut.leagues[0].divisions[1].teams = sortTeams(AL_CENTRAL);
  teamsDataOut.leagues[0].divisions[2].teams = sortTeams(AL_WEST);
  teamsDataOut.leagues[1].divisions[0].teams = sortTeams(NL_EAST);
  teamsDataOut.leagues[1].divisions[1].teams = sortTeams(NL_CENTRAL);
  teamsDataOut.leagues[1].divisions[2].teams = sortTeams(NL_WEST);
  return teamsDataOut;
};
export var DEFAULT_NAV_VARIABLES = {
  sitesearch: true,
  siteaccount: true,
  ismlbtvnav: false
};

/**
 * Parse `variables` data from Forge VSM and always include/override/return default values
 * @param {Array} variables - Array of raw variables data
 * @returns object - Parsed variables data
 */
export var transformNavVariables = function transformNavVariables() {
  var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(variables) || !variables.length) {
    return DEFAULT_NAV_VARIABLES;
  }
  return variables === null || variables === void 0 ? void 0 : variables.reduce(function (obj, variable) {
    var _ref3 = variable || {},
      key = _ref3.key,
      jsonBody = _ref3.jsonBody;
    //Extracts key name 'hidesocial' from "hidesocial.*.*.*"
    var keyMatches = key === null || key === void 0 ? void 0 : key.match(/(^\w+|\d+)/gi);
    if (keyMatches && keyMatches.length) {
      var parsedKey = keyMatches[0];
      var parsedValue;
      try {
        var parsedJson = jsonBody && JSON.parse(jsonBody);
        var _ref4 = parsedJson || {},
          rawValue = _ref4.Value;
        // If Value is 'true' or 'false', convert it to actual Boolean
        parsedValue = /true|false/i.test(rawValue) ? /true/i.test(rawValue) : rawValue;
      } catch (_unused) {
        console.error("Error [transformNavVariables]: No valid 'jsonBody' available for ", key);
      }
      obj[parsedKey] = parsedValue;
    }
    return obj;
  }, _objectSpread({}, DEFAULT_NAV_VARIABLES));
};

//TODO pass in properties into here with club team id
export var modelStyleProps = function modelStyleProps() {
  var propertiesFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clubId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mlb';
  var _propertiesFile$prope = propertiesFile.properties,
    properties = _propertiesFile$prope === void 0 ? {} : _propertiesFile$prope,
    _propertiesFile$palet = propertiesFile.palette,
    palette = _propertiesFile$palet === void 0 ? {} : _propertiesFile$palet;
  var defaultHeaderPrimaryLogo = clubId !== 'mlb' ? "//www.mlbstatic.com/team-logos/team-cap-on-dark/".concat(clubId, ".svg") : '//www.mlbstatic.com/team-logos/league-on-dark/1.svg';
  return {
    theme: {
      logoBarBackgroundColor: palette.headerMastheadBackgroundColor,
      navBackgroundColor: palette.headerNavigationBackgroundColor,
      navBorderColor: palette.headerNavigationBorderColor,
      navTextColor: palette.headerNavigationTextColor,
      navTextColorHover: palette.headerNavigationTextColorHover,
      sideNavBackgroundColorHover: palette.headerNavigationBorderColor,
      sideNavBackgroundColor: palette.headerMastheadBackgroundColor,
      spotlightBackgroundColor: palette.buttonSpotlightBackgroundColor,
      spotlightBackgroundColorHover: palette.buttonSpotlightBackgroundColorHover,
      spotlightTextColor: palette.buttonSpotlightTextColor,
      spotlightTextColorHover: palette.buttonSpotlightTextColorHover,
      headerMastheadBackgroundColor: palette.headerMastheadBackgroundColor,
      headerNavigationBackgroundColor: palette.headerNavigationBackgroundColor,
      headerNavigationBorderColor: palette.headerNavigationBorderColor,
      headerNavigationTextColor: palette.headerNavigationTextColor,
      headerNavigationTextColorHover: palette.headerNavigationTextColorHover,
      headerMastheadTaglineContainerHeight: properties.headerMastheadTaglineContainerHeight,
      headerMastheadTaglineContainerWidth: properties.headerMastheadTaglineContainerWidth,
      headerMastheadTaglineContainerLeft: properties.headerMastheadTaglineContainerLeft,
      headerMastheadTaglineContainerTop: properties.headerMastheadTaglineContainerTop,
      buttonSpotlightBackgroundColor: palette.buttonSpotlightBackgroundColor,
      buttonSpotlightBackgroundColorHover: palette.buttonSpotlightBackgroundColorHover,
      buttonSpotlightTextColor: palette.buttonSpotlightTextColor,
      buttonSpotlightTextColorHover: palette.buttonSpotlightTextColorHover
    },
    clubProps: {
      primaryLogo: properties.headerPrimaryLogo && properties.headerPrimaryLogo.url || defaultHeaderPrimaryLogo,
      urlLogo: properties.urlLogo && properties.urlLogo.url,
      logoUrl: properties.headerPrimaryLogo && properties.headerPrimaryLogo.logoUrl,
      sponsorLogo: properties.navigationMastheadSponsorImage && (properties.navigationMastheadSponsorImage.binaryFile || properties.navigationMastheadSponsorImage.url),
      sponsorUrl: properties.navigationMastheadSponsorImage && properties.navigationMastheadSponsorImage.url,
      tagline: properties.headerMastheadTagline && properties.headerMastheadTagline.url
    }
  };
};
export var __test = {
  customPropsToObj: customPropsToObj,
  modelStyleProps: modelStyleProps,
  getActiveSection: getActiveSection,
  transformHeaderData: transformHeaderData,
  transformNavItem: transformNavItem,
  transformTeamsData: transformTeamsData,
  transformToSlug: transformToSlug,
  getSubNavItems: getSubNavItems,
  transformNavVariables: transformNavVariables,
  filterTopNavs: filterTopNavs
};